import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { ActiveStatusEnum } from '@models';

// PascalCase throughout — the API's Newtonsoft config keeps C# property casing on the wire.

export interface ShippingTransferTileDto {
  Id: string;
  Name: string;
  ActiveStatusId: ActiveStatusEnum;
  MemberCount: number;
  AddressCount: number;
  /** A few address descriptions; the full list would not fit on a tile. */
  AddressNames: string[];
  CannotReceiveReason: string | null;
  WarningReason: string | null;
}

export interface ShippingTransferUserDto {
  Id: string;
  /** "Last, First" — the roster is read and sorted by surname. */
  Name: string;
  FirstName: string;
  LastName: string;
  /** Every group this user is in today. More than one means a transfer will remove the rest. */
  CurrentGroupNames: string[];
  CurrentGroupIds: string[];
}

export interface ShippingTransferBoardDto {
  AccountId: string;
  ProgramId: string;
  ProgramName: string;
  DisqualifiedReason: string | null;
  Tiles: ShippingTransferTileDto[];
  Users: ShippingTransferUserDto[];
}

export interface ShippingTransferRequestDto {
  AccountId: string;
  ProgramId: string;
  TargetShippingUserGroupId: string;
  AccountUserIds: string[];
}

export interface ShippingTransferResultDto {
  UsersTransferred: number;
  UsersSkipped: number;
  MapsAdded: number;
  MapsDeleted: number;
  TargetGroupName: string;
  TransferredUserNames: string[];
  TransferredUserIds: string[];
  Problems: string[];
}

@Injectable({ providedIn: 'root' })
export class ShippingTransferApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}Account`;

  getBoard(accountId: string, programId: string): Observable<ShippingTransferBoardDto> {
    const params = new HttpParams().set('accountId', accountId).set('programId', programId);
    return this.http.get<ShippingTransferBoardDto>(`${this.baseUrl}/GetShippingTransferBoard`, { params });
  }

  transfer(request: ShippingTransferRequestDto): Observable<ShippingTransferResultDto> {
    return this.http.post<ShippingTransferResultDto>(
      `${this.baseUrl}/TransferAccountUsersToShippingGroup`, request);
  }
}
